















































import { defineComponent, ref, toRefs, watch } from '@vue/composition-api'
import { useGetters } from '../store/useGetters'
import KaiSpace from './transcript/KaiSpace.vue'
import KaiWord from './transcript/KaiWord.vue'
import { Word } from '../models/word'

export default defineComponent({
  name: 'TranscriptPartWords',
  components: {
    KaiWord,
    KaiSpace
  },
  props: {
    isEditable: {
      type: Boolean,
      required: true,
      default: false
    },
    words: {
      type: Array as () => Word[],
      required: true
    },
    spelled: {
      type: Boolean,
      default: false
    },
    partId: {
      required: true,
      type: String
    },
    speakerId: {
      type: Number
    },
    speakerName: {
      type: String
    }
  },
  setup(props, { emit }) {
    const { spelled, isEditable, words } = toRefs(props)
    const spelledIds = ref<string[]>([])

    const getters = useGetters({
      selectedSpeakerPartTimecode: 'conversation/selectedSpeakerPartTimecode',
      searchWordToHashMap: 'conversation/searchWordToHashMap',
      appliedTags: 'transcriptTags/wordsTags',
      spelledWords: 'conversation/spelledWords'
    })

    watch(getters.spelledWords, () => {
      if (isEditable.value) {
        return
      }

      if (spelled.value) {
        spelledIds.value = getters.spelledWords.value.map((w: Word) => w.id)
      } else if (spelledIds.value.length) {
        spelledIds.value = []
      }
    })

    function wordSpelledKey(id?: string) {
      if (!id) {
        return
      }

      const isSpelled = spelledIds.value.includes(id)
      return isSpelled ? '-spelled' : ''
    }

    function getWordKey(word: Word) {
      // return `word-${word.id}-${spelledIds.value.length ? wordSpelledKey(word.id) : ''}`
      return `word-${word.id}-${word.version}-${
        spelledIds.value.length ? wordSpelledKey(word.id) : ''
      }`
    }

    function getSpaceKey(word: Word) {
      return 'space ' + word.id + '-' + word.version
    }

    function isWordSpelled(word: Word) {
      return !!wordSpelledKey(word.id)?.length
    }

    function isWordShown(word: Word) {
      return isEditable && words.value.length > 1 ? !word.isSpare : true
    }

    function isSpaceShown(word: Word) {
      return word.text.trim().length || words.value.length === 0
        ? word.isSpaceRequired && !word.isSpare
        : word.partIndex === 0
        ? word.isSpaceRequired
        : false
    }

    function handlePartClick() {
      if (isEditable.value) {
        emit('part-focus')
      }
    }

    return {
      appliedTags: getters.appliedTags,
      spelledIds,
      searchMap: getters.searchWordToHashMap,
      getWordKey,
      getSpaceKey,
      isWordSpelled,
      isWordShown,
      isSpaceShown,
      handlePartClick
    }
  }
})
